import "core-js/modules/es.promise.js";

/* eslint-disable @typescript-eslint/no-explicit-any */
var Deferred =
/** @class */
function () {
  function Deferred() {
    var _this = this;

    this.resolve = function (value) {
      _this._resolve(value);
    };

    this.reject = function (reason) {
      _this._reject(reason);
    };

    this._promise = new Promise(function (resolve, reject) {
      _this._resolve = resolve;
      _this._reject = reject;
    });
  }

  Object.defineProperty(Deferred.prototype, "promise", {
    get: function get() {
      return this._promise;
    },
    enumerable: false,
    configurable: true
  });
  return Deferred;
}();

export { Deferred };